import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { extractToken, extractUser } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data?.user || data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: si retour OAuth, AuthCallback échange le session_id d'abord — ne pas appeler /auth/me ici
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const afterAuth = async (data) => {
    const token = extractToken(data);
    if (token) localStorage.setItem("fx_token", token);
    const u = extractUser(data);
    if (u) {
      setUser(u);
      return u;
    }
    const { data: me } = await api.get("/auth/me");
    const mu = me?.user || me;
    setUser(mu);
    return mu;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/demo-login", { email, password });
    return afterAuth(data);
  };

  const register = async (email, password) => {
    const { data } = await api.post("/auth/register", { email, password });
    return afterAuth(data);
  };

  const loginWithSessionId = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    return afterAuth(data);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("fx_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithSessionId, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
